import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body1, Button, Caption1, Card, CardHeader, Field, Input, makeStyles, Subtitle1, tokens, } from '@fluentui/react-components';
import { useState } from 'react';
const useStyles = makeStyles({
    page: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100%',
        padding: tokens.spacingHorizontalL,
        boxSizing: 'border-box',
        backgroundColor: tokens.colorNeutralBackground2,
    },
    card: { width: '100%', maxWidth: '400px' },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
    },
    hint: { color: tokens.colorNeutralForeground3 },
});
/**
 * Entrada do modo dev: qualquer e-mail, sem senha. A pessoa é cadastrada no
 * primeiro acesso, sem perfil; as permissões vêm do banco, como em produção.
 */
export function DevSignIn({ onSignIn }) {
    const styles = useStyles();
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const submit = (event) => {
        event.preventDefault();
        const trimmed = email.trim();
        onSignIn({
            kind: 'user',
            email: trimmed,
            name: name.trim() || (trimmed.split('@')[0] ?? trimmed),
        });
    };
    return (_jsx("main", { className: styles.page, children: _jsxs(Card, { className: styles.card, children: [_jsx(CardHeader, { header: _jsx(Subtitle1, { children: "Entrar (modo de desenvolvimento)" }), description: _jsx(Body1, { children: "Fora do Teams, o backend aceita qualquer e-mail." }) }), _jsxs("form", { className: styles.form, onSubmit: submit, children: [_jsx(Field, { label: "E-mail", required: true, children: _jsx(Input, { type: "email", value: email, onChange: (_, data) => setEmail(data.value) }) }), _jsx(Field, { label: "Nome", children: _jsx(Input, { value: name, onChange: (_, data) => setName(data.value) }) }), _jsx(Button, { appearance: "primary", type: "submit", children: "Entrar" }), _jsx(Caption1, { className: styles.hint, children: "Para ter acesso a tudo: pnpm env:local backend:cli rbac:grant <e-mail> admin" })] })] }) }));
}
//# sourceMappingURL=DevSignIn.js.map